import { CommonButton } from '@components/common/CommonButton';
import { CommonChip } from '@components/common/CommonChip';
import { useTranslation } from 'react-i18next';
import { PromoCode as PromoCodeType } from 'src/models/general';
import { ReactComponent as PlusBtn } from '@assets/images/plusIcon.svg';
import './style.scss';

type PromoCodeProps = {
  onPromoCodeDelete: (value?: string) => void;
  onPromoCodeAdd: () => void;
  promoCode?: PromoCodeType | null;
  hideDiscountAmount?: boolean;
};

export const PromoCodeCharge = ({
  onPromoCodeDelete,
  onPromoCodeAdd,
  promoCode = null,
  hideDiscountAmount,
}: PromoCodeProps) => {
  const { t } = useTranslation();

  return (
    <div className="promo-code-charge" data-testid="promo-code-charge">
      {promoCode ? (
        <div data-testid="promo-code-charge__discount" className="promo-code-charge__discount">
          <CommonChip onClose={() => onPromoCodeDelete(promoCode?.value)}>
            {promoCode.value}
          </CommonChip>
          {!hideDiscountAmount && (
            <div className="promo-code-discount-container">
              <span className="promo-code-charge__price">
                {promoCode?.discount.amount > 0
                && `-${promoCode?.discount.currency}${promoCode?.discount.amount.toFixed(2)}`}
              </span>
              <span className="promo-code-charge__price">
                {promoCode?.freeShipping && (
                  <span>
                    {promoCode?.discount.amount > 0 && '+ '}
                    {t('cart.summary.promoCode.freeShipping')}
                  </span>
                )}
              </span>
            </div>
          ) }
        </div>
      ) : (
        <CommonButton
          data-testid="promo-code-charge__add-btn"
          icon={<PlusBtn />}
          className="text-button-1"
          onClick={onPromoCodeAdd}
          type="tertiary"
        >
          {t('cart.summary.promoCode.addPromoCode')}
        </CommonButton>
      )}
    </div>
  );
};
